import { createSelector } from 'reselect';
import { TZDate } from '@date-fns/tz';

import type { RootState } from 'config/store/reducers';
import { getZonedEndOfDay } from 'utils/date';
import { hasSomeAttributes } from 'utils/utils';
import { isCampaign } from 'constants/EntityConstants';
import { MODE } from 'modules/entity/constants';
import { MODULES } from 'modules/entity/subEntities/intervention/constants';
import { getDealerTimezone, getEntity } from 'modules/entity/selectors';

const getState = (state: RootState) => state.intervention;

export const getUI = createSelector(getState, (intervention) => intervention.ui);

export const getDepositAmount = createSelector(getEntity, (intervention) =>
  Math.max(0, intervention?.depositAmount ?? 0));

export const hasVehicleInfo = createSelector(getEntity, ({ vehicleInfo = {} }) =>
  hasSomeAttributes(vehicleInfo, ['model', 'registration', 'mileage', 'vin', 'registrationDate', 'inspectionDate']));

export const isParts = createSelector(getEntity, ({ mode }) => mode === MODE.PARTS);
export const isSales = createSelector(getEntity, ({ mode }) => mode === MODE.SALES);
export const isAfterSales = createSelector(getEntity, ({ mode }) => mode === MODE.TECHNICIAN);
export const isStock = createSelector(getEntity, ({ module }) => module === MODULES.STOCK_VO);
export const isReminder = createSelector(getEntity, ({ module }) => module === MODULES.REMINDER);
export const isSalesOrParts = createSelector(
  isSales,
  isParts,
  (isSalesMode, isPartsMode) => isSalesMode || isPartsMode
);

const getExpirationDate = createSelector(getEntity, ({ expirationDate, timeToReply }) => expirationDate ?? timeToReply);
export const getTimeToReply = createSelector(
  getExpirationDate,
  getDealerTimezone,
  isAfterSales,
  (expirationDate, timezone, isAfterSale) => {
    if (isAfterSale && !isCampaign) {
      return expirationDate ? new TZDate(expirationDate, timezone) : undefined;
    }
    return expirationDate ? getZonedEndOfDay(expirationDate, timezone) : undefined;
  }
);
